import Uuid from '../model/Uuid';
import { StadiumMaterialuEnum } from '../model/legislativnyMaterial/StadiumMaterialu';

const baseUrl = '/legislativne-procesy/SK';

export default {
  home: {
    name: 'Domov',
    to: '/',
  },
  loading: { to: '/loading' },
  notFound: '/stranka-nenajdena',
  mojeUlohy: '/moje-ulohy',
  ulohyOrganizacie: {
    list: '/ulohy-organizacie',
    detail: {
      name: (fullName = ''): string => `Úlohy - ${fullName}`,
      raw: '/ulohy-organizacie/:uuid',
      withParams: (uuid: string): string => `/ulohy-organizacie/${uuid}`,
    },
  },
  procesy: {
    list: '/legislativne-procesy',
    sledovane: '/sledovane-procesy',
    new: '/vytvorenie-procesu',
    edit: {
      raw: `${baseUrl}/:type/:year/:index/uprava`,
      withParams: (type: string, year: number, index: number):
        string => `${baseUrl}/${type}/${year}/${index}/uprava`,
    },
    terminate: {
      raw: `${baseUrl}/:type/:year/:index/ukoncit/:pracovnyKrokId`,
      withParams: (type: string, year: number, index: number, pracovnyKrokId: string):
        string => `${baseUrl}/${type}/${year}/${index}/ukoncit/${pracovnyKrokId}`,
    },
    admin: {
      mpk: {
        config: {
          raw: `${baseUrl}/:type/:year/:index/admin/mpk`,
          withParams: (type: string, year: number, index: number):
            string => `${baseUrl}/${type}/${year}/${index}/admin/mpk`,
        },
        start: {
          raw: `${baseUrl}/:type/:year/:index/admin/mpk/:pracovnyKrokId`,
          withParams: (type: string, year: number, index: number, pracovnyKrokId: string):
            string => `${baseUrl}/${type}/${year}/${index}/admin/mpk/${pracovnyKrokId}`,
        },
        cancel: {
          raw: `${baseUrl}/:type/:year/:index/admin/zrusenie-mpk`,
          withParams: (type: string, year: number, index: number):
            string => `${baseUrl}/${type}/${year}/${index}/admin/zrusenie-mpk`,
        },
      },
      vyjadrenia: {
        config: {
          raw: `${baseUrl}/:type/:year/:index/admin/vyjadrenia`,
          withParams: (type: string, year: number, index: number):
            string => `${baseUrl}/${type}/${year}/${index}/admin/vyjadrenia`,
        },
        start: {
          raw: `${baseUrl}/:type/:year/:index/admin/vyjadrenia/:pracovnyKrokId`,
          withParams: (type: string, year: number, index: number, pracovnyKrokId: string):
            string => `${baseUrl}/${type}/${year}/${index}/admin/vyjadrenia/${pracovnyKrokId}`,
        },
      },
      gestor: {
        raw: `${baseUrl}/:type/:year/:index/admin/zmena-gestora`,
        withParams: (type: string, year: number, index: number):
          string => `${baseUrl}/${type}/${year}/${index}/admin/zmena-gestora`,
      },
      zmenaStadiaMaterialu: {
        raw: `${baseUrl}/:type/:year/:index/admin/zmena-stadia-materialu`,
        withParams: (type: string, year: number, index: number):
          string => `${baseUrl}/${type}/${year}/${index}/admin/zmena-stadia-materialu`,
      },
      notifikacie: {
        raw: `${baseUrl}/:type/:year/:index/admin/notifikacie`,
        withParams: (type: string, year: number, index: number):
          string => `${baseUrl}/${type}/${year}/${index}/admin/notifikacie`,
      },
    },
    detail: {
      raw: `${baseUrl}/:type/:year/:index`,
      withParams: (type: string, year: number, index: number):
        string => `${baseUrl}/${type}/${year}/${index}`,
      sprievodneDokumenty: {
        list: {
          raw: `${baseUrl}/:type/:year/:index/sprievodne-dokumenty`,
          withParams: (type: string, year: number, index: number, stadiumUuid = ''):
            string => `${baseUrl}/${type}/${year}/${index}/sprievodne-dokumenty?stadiumUuid=${stadiumUuid}`,
        },
        edit: {
          raw: `${baseUrl}/:type/:year/:index/sprievodne-dokumenty/uprava`,
          withParams: (type: string, year: number, index: number):
            string => `${baseUrl}/${type}/${year}/${index}/sprievodne-dokumenty/uprava`,
        },
        editAsAdmin: {
          raw: `${baseUrl}/:type/:year/:index/sprievodne-dokumenty/uprava`,
          withParams: (type: string, year: number, index: number, stadiumUuid = ''):
            string => `${baseUrl}/${type}/${year}/${index}/sprievodne-dokumenty/uprava?stadiumUuid=${stadiumUuid}`,
        },
        editOrder: {
          raw: `${baseUrl}/:type/:year/:index/sprievodne-dokumenty/upravit-poradie`,
          withParams: (type: string, year: number, index: number, stadiumUuid: string):
              string => `${baseUrl}/${type}/${year}/${index}/sprievodne-dokumenty/upravit-poradie?stadiumUuid=${stadiumUuid}`, // eslint-disable-line
        },
        spravaOUcastiVerejnosti: {
          create: {
            raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/sprievodne-dokumenty`
              + '/sprava-o-ucasti-verejnosti/vytvorenie',
            withParams: (type: string, year: number, index: number, stadiumUuid: Uuid):
              string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/sprievodne-dokumenty`
              + '/sprava-o-ucasti-verejnosti/vytvorenie',
          },
          edit: {
            raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/sprievodne-dokumenty/`
            + 'sprava-o-ucasti-verejnosti/uprava',
            withParams: (type: string, year: number, index: number, stadiumUuid: Uuid):
              string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/sprievodne-dokumenty`
              + '/sprava-o-ucasti-verejnosti/uprava',
          },
        },
        navrhUzneseniaVlady: {
          create: {
            raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/sprievodne-dokumenty/navrh-uznesenia-vlady`
              + '/vytvorenie',
            withParams: (type: string, year: number, index: number, stadiumUuid: Uuid):
              string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/sprievodne-dokumenty`
              + '/navrh-uznesenia-vlady/vytvorenie',
          },
          edit: {
            raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/sprievodne-dokumenty/navrh-uznesenia-vlady`
              + '/uprava',
            withParams: (type: string, year: number, index: number, stadiumUuid: Uuid):
              string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/sprievodne-dokumenty`
              + '/navrh-uznesenia-vlady/uprava',
          },
        },
        uznesenieVlady: {
          create: {
            raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/sprievodne-dokumenty/uznesenie-vlady/`
             + 'vytvorenie',
            withParams: (type: string, year: number, index: number, stadiumUuid: Uuid):
              string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/sprievodne-dokumenty`
              + '/uznesenie-vlady/vytvorenie',
          },
          edit: {
            raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/sprievodne-dokumenty/uznesenie-vlady/uprava`,
            withParams: (type: string, year: number, index: number, stadiumUuid: Uuid):
              string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/sprievodne-dokumenty`
              + '/uznesenie-vlady/uprava',
          },
        },
        dolozkaVplyvov: {
          create: {
            raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/sprievodne-dokumenty/dolozka-vplyvov/`
              + 'vytvorenie',
            withParams: (type: string, year: number, index: number, stadiumUuid: Uuid):
              string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/sprievodne-dokumenty`
              + '/dolozka-vplyvov/vytvorenie',
          },
          edit: {
            raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/sprievodne-dokumenty/dolozka-vplyvov/uprava`,
            withParams: (type: string, year: number, index: number, stadiumUuid: Uuid):
              string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/sprievodne-dokumenty`
              + '/dolozka-vplyvov/uprava',
          },
        },
        dolozkaZlucitelnosti: {
          create: {
            raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/sprievodne-dokumenty`
              + '/dolozka-zlucitelnosti/vytvorenie',
            withParams: (type: string, year: number, index: number, stadiumUuid: Uuid):
              string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/sprievodne-dokumenty`
              + '/dolozka-zlucitelnosti/vytvorenie',
          },
          edit: {
            raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/sprievodne-dokumenty`
              + '/dolozka-zlucitelnosti/uprava',
            withParams: (type: string, year: number, index: number, stadiumUuid: Uuid):
              string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/sprievodne-dokumenty`
              + '/dolozka-zlucitelnosti/uprava',
          },
        },
        obalMaterialu: {
          select: {
            raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/stadium/:stadium/sprievodne-dokumenty`
              + '/obal-materialu/vytvorenie',
            withParams: (
              type: string,
              year: number,
              index: number,
              stadiumUuid: Uuid,
              stadium: StadiumMaterialuEnum,
            ): string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/stadium/${stadium}`
            + '/sprievodne-dokumenty/obal-materialu/vytvorenie',
          },
          vseobecny: {
            create: {
              raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/stadium/:stadium/sprievodne-dokumenty`
                + '/obal-materialu/vseobecny-material/vytvorenie',
              withParams: (type: string, year: number, index: number, stadiumUuid: Uuid, stadium: StadiumMaterialuEnum):
                string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/stadium/${stadium}/`
                + 'sprievodne-dokumenty/obal-materialu/vseobecny-material/vytvorenie',
            },
            edit: {
              raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/stadium/:stadium/sprievodne-dokumenty`
                + '/:sprievodnyDokumentUuid/obal-materialu/vseobecny-material/uprava',
              withParams: (
                type: string,
                year: number,
                index: number,
                sprievodnyDokumentUuid: Uuid,
                stadiumUuid: Uuid,
                stadium: StadiumMaterialuEnum,
              ): string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/stadium/${stadium}`
                + `/sprievodne-dokumenty/${sprievodnyDokumentUuid}/obal-materialu/vseobecny-material/uprava`,
            },
          },
          obalNrSr: {
            create: {
              raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/sprievodne-dokumenty/obal-materialu`
                + '/material-nrsr/vytvorenie',
              withParams: (type: string, year: number, index: number, stadiumUuid: Uuid):
                string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/sprievodne-dokumenty`
                + '/obal-materialu/material-nrsr/vytvorenie',
            },
            edit: {
              raw: `${baseUrl}/:type/:year/:index/stadiumUuid/:stadiumUuid/sprievodne-dokumenty/:sprievodnyDokumentUuid`
                + '/obal-materialu/material-nrsr/uprava',
              withParams: (
                type: string,
                year: number,
                index: number,
                sprievodnyDokumentUuid: string,
                stadiumUuid: Uuid,
              ): string => `${baseUrl}/${type}/${year}/${index}/stadiumUuid/${stadiumUuid}/sprievodne-dokumenty`
               + `/${sprievodnyDokumentUuid}/obal-materialu/material-nrsr/uprava`,
            },
          },
        },
      },
    },
    predkladatel: {
      edit: {
        raw: `${baseUrl}/:type/:year/:index/predkladatel/uprava`,
        withParams: (type: string, year: number, index: number):
          string => `${baseUrl}/${type}/${year}/${index}/predkladatel/uprava`,
      },
    },
    vyjadrenia: {
      raw: `${baseUrl}/:type/:year/:index/vyjadrenia/:pracovnyKrokId`,
      withParams: (type: string, year: number, index: number, pracovnyKrokId: string):
        string => `${baseUrl}/${type}/${year}/${index}/vyjadrenia/${pracovnyKrokId}`,
    },
    mpk: {
      raw: `${baseUrl}/:type/:year/:index/mpk/:pracovnyKrokId`,
      withParams: (type: string, year: number, index: number, pracovnyKrokId: string):
        string => `${baseUrl}/${type}/${year}/${index}/mpk/${pracovnyKrokId}`,
      cancel: {
        raw: `${baseUrl}/:type/:year/:index/zrusenie-mpk/:pracovnyKrokId`,
        withParams: (type: string, year: number, index: number, pracovnyKrokId: string):
          string => `${baseUrl}/${type}/${year}/${index}/zrusenie-mpk/${pracovnyKrokId}`,
      },
    },
    rokovanie: {
      raw: `${baseUrl}/:type/:year/:index/rokovanie-pov/:pracovnyKrokId`,
      withParams: (type: string, year: number, index: number, pracovnyKrokId: string):
        string => `${baseUrl}/${type}/${year}/${index}/rokovanie-pov/${pracovnyKrokId}`,
    },
    dolezitost: {
      raw: `${baseUrl}/:type/:year/:index/dolezitost-akt-eu`,
      withParams: (type: string, year: number, index: number):
        string => `${baseUrl}/${type}/${year}/${index}/dolezitost-akt-eu`,
    },
    gestor: {
      raw: `${baseUrl}/:type/:year/:index/urcenie-gestora`,
      withParams: (type: string, year: number, index: number):
        string => `${baseUrl}/${type}/${year}/${index}/urcenie-gestora`,
      odmietnutie: {
        raw: `${baseUrl}/:type/:year/:index/odmietnutie-gestora/:pracovnyKrokId`,
        withParams: (type: string, year: number, index: number, pracovnyKrokId: string):
          string => `${baseUrl}/${type}/${year}/${index}/odmietnutie-gestora/${pracovnyKrokId}`,
      },
    },
    kategoria: {
      raw: `${baseUrl}/:type/:year/:index/kategoria-akt-eu`,
      withParams: (type: string, year: number, index: number):
        string => `${baseUrl}/${type}/${year}/${index}/kategoria-akt-eu`,
    },
    namietkaKuGestorstvu: {
      raw: `${baseUrl}/:type/:year/:index/namietka-ku-gestorstvu/:pracovnyKrokId`,
      withParams: (type: string, year: number, index: number, pracovnyKrokId: string):
        string => `${baseUrl}/${type}/${year}/${index}/namietka-ku-gestorstvu/${pracovnyKrokId}`,
    },
    prechodZapisStanoviska: {
      raw: `${baseUrl}/:type/:year/:index/prechod-zapis-stanoviska/:pracovnyKrokId`,
      withParams: (type: string, year: number, index: number, pracovnyKrokId: string)
        : string => `${baseUrl}/${type}/${year}/${index}/prechod-zapis-stanoviska/${pracovnyKrokId}`,
    },
    podpisPredseda: {
      raw: `${baseUrl}/:type/:year/:index/podpis-predseda/:pracovnyKrokId`,
      withParams: (type: string, year: number, index: number, pracovnyKrokId: string)
        : string => `${baseUrl}/${type}/${year}/${index}/podpis-predseda/${pracovnyKrokId}`,
      obalMaterialu: {
        create: {
          raw: `${baseUrl}/:type/:year/:index/podpis-predseda/:pracovnyKrokId/obal-materialu/vytvorenie`,
          withParams(type: string, year: number, index: number, pracovnyKrokId: string): string {
            return `${baseUrl}/${type}/${year}/${index}/podpis-predseda/${pracovnyKrokId}/obal-materialu/vytvorenie`;
          },
        },
        edit: {
          raw: `${baseUrl}/:type/:year/:index/podpis-predseda/:pracovnyKrokId/obal-materialu/uprava`,
          withParams(type: string, year: number, index: number, pracovnyKrokId: string): string {
            return `${baseUrl}/${type}/${year}/${index}/podpis-predseda/${pracovnyKrokId}/obal-materialu/uprava`;
          },
        },
      },
    },
    vyhlasenievZbierke: {
      raw: `${baseUrl}/:type/:year/:index/vyhlasene-v-zbierke/:pracovnyKrokId`,
      withParams: (type: string, year: number, index: number, pracovnyKrokId: string):
        string => `${baseUrl}/${type}/${year}/${index}/vyhlasene-v-zbierke/${pracovnyKrokId}`,
    },
    predbeznaInformacia: {
      list: '/predbezne-informacie',
    },
    indexerProcesy: {
      list: '/indexer-procesy',
    },
    indexerPredbezneInformacie: {
      list: '/indexer-predbezne-informacie',
    },
  },
};
